import fr from './locales/fr'
import en from './locales/en'
import type { ApexOptions } from 'apexcharts'

export class Chart {
  type: string
  series: object = {}
  options: object = {}

  constructor() {
    this.options = {
      chart: {
        locales: [fr, en],
        defaultLocale: 'fr',
        height: '350px',
        fontFamily: 'inherit',
        toolbar: {
          show: true,
          tools: {
            download: true
          }
        }
      }
    } as ApexOptions
  }
}
